import { connect } from 'react-redux';
import _ from 'lodash';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { getExtras, getErrors } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  fixBeforeMonthlyInsuranceAmounts,
  getStaledRevisions,
  getTargetRevisions
} from 'src/reducers/reports/monthlyRevisions';
import {
  isLoading,
  revisionMonthsSearchFormSelector,
  ITEM_NAME_FETCH_REVISION_MONTH_OPTIONS,
  fetchRevisionMonthOptions
} from 'src/reducers/searchForm';
import Header from '../components/Header';

const mapStateToProps = state => ({
  revisionYearMonths: getSelectOptions(state, 'revisionYearMonths'),
  yearMonth: revisionMonthsSearchFormSelector(state, 'yearMonth'),
  extras: getExtras(REDUCER_NAME, state),
  hasErrors: !_.isEmpty(getErrors(REDUCER_NAME, state)),
  isOptionsLoading: isLoading(ITEM_NAME_FETCH_REVISION_MONTH_OPTIONS, state),
  staledRevisions: getStaledRevisions(state),
  targetCount: getTargetRevisions(state) ? getTargetRevisions(state).length : []
});

const mapDispatchToProps = dispatch => ({
  fetchRevisionMonthOptions: () => {
    dispatch(fetchRevisionMonthOptions());
  },
  fixBeforeMonthlyInsuranceAmounts: revisionIds => {
    dispatch(fixBeforeMonthlyInsuranceAmounts(revisionIds));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
